// extracted by mini-css-extract-plugin
export default {"container":"Game2048Page_container__tNjVT","title":"Game2048Page_title__zFFs4","gameContainer":"Game2048Page_gameContainer__KgaEN"};